// extracted by mini-css-extract-plugin
module.exports = {"band_config_travel_table":"styles_band_config_travel_table___5_uu","travel_content_tab":"styles_travel_content_tab__YCAXR","extra_img":"styles_extra_img__Kcsmf"};